import React from 'react';
import {view} from '@sail/ui';
import BusinessOperationsImage from 'docs/images/home/business-operations.svg';
import FinancialServicesImage from 'docs/images/home/financial-services.svg';

const basic = {
  rendered: (
    <view.img
      src={BusinessOperationsImage}
      width="484"
      height="207"
      alt="Gross margin"
    />
  ),
  source: `<Img
  src="https://stripe.com/margin.svg"
  width="484"
  height="207"
  alt="Gross margin"
>`,
};

const srcSet = {
  rendered: (
    <view.img
      srcSet={`${FinancialServicesImage} 480w, ${FinancialServicesImage} 800w`}
      sizes="(max-width: 600px) 480px, 800px"
      width="484"
      height="207"
      alt="Daily sales"
    />
  ),
  source: `<Img
  srcSet="https://stripe.com/daily-sales.jpg 480w, https://stripe.com/daily-sales-large.jpg 800w"
  sizes="(max-width: 600px) 480px, 800px"
  width="484"
  height="207"
  alt="Daily sales"
>`,
};

export const ImgExamples = {basic, srcSet};
